import React from 'react';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives/compiled';

const HealthcheckHeader = (): React.JSX.Element => {
	return (
		<>
			<Stack space="space.200">
				{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
				<Heading size="large">Extra Auth Healthcheck</Heading>
				{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
				<Text>Status of Extra Authenticated Application Links for your Jira Cloud site.</Text>
			</Stack>
		</>
	);
};

export default HealthcheckHeader;
